<template>
  <div class="items-flex">
    <v-combobox
      v-model="myCustomType"
      class="custom-type-box"
      :items="items"
      :label="$t('views.stocks.stockModal.customType.label')"
      :disabled="disabled"
      hide-details
      maxLength="100"
    />
    <span class="ml-2">
      <InfoIcon :size="15" :text="$t('views.stocks.stockModal.customType.help')" />
    </span>
  </div>
</template>

<script>
import InfoIcon from '@/views/components/common/InfoIcon'
const { getSummary } = require('@/lib/api')

export default {
  components: { InfoIcon },
  props: {
    value: {
      type: String,
      default: null,
    },
    group: {
      type: null,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      myCustomType: null,
      items: [],
    }
  },
  watch: {
    myCustomType: {
      handler() {
        if (this.myCustomType === this.value) return
        this.$emit('input', this.myCustomType)
      },
      deep: true,
    },
    value: {
      handler() {
        this.myCustomType = this.value
      },
      immediate: true,
    },
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      this.loading = true
      const customTypeSummary = await getSummary({
        type: 'custom-type',
        queryString: { group: 'position' },
      })
      this.items = customTypeSummary.data
      this.loading = false
    },
  },
}
</script>

<style lang="scss">
.custom-type-box {
  .v-select__selections {
    margin-bottom: 0px !important;
  }
}
</style>
